import styled from 'styled-components';
import OverviewCard from './OverviewCard';
import { APPLICANT, REVIEWER, statusLookup } from 'utility/lookup';
import { useSelector } from 'react-redux';
import { applicationPath, postApprovalDocumentPath, menuFolder } from 'utility/menuFolder';

const SLayout = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const CardLayout = ({ data = [], type }) => {
    const userRole = useSelector((state) => state.user.role);

    const paths = {
        application: applicationPath,
        postApprovalDocument: postApprovalDocumentPath,
    };

    const getDisplayCount2 = (data) => {
        if (userRole === APPLICANT || userRole === REVIEWER) {
            return `${data.pendingCount} / ${data.totalCount}`;
        } else {
            return data.totalCount;
        }
    };

    const getCardName = (data) => {
        const text =
            statusLookup.find((item) => {
                return data.name === item.key;
            })?.statusDisplay || 'Not Defined';
        const label = getStatusLabel(data);
        return label ? label : text;
    };

    const getStatusLabel = (data) => {
        const item = menuFolder[type][data.name];

        const label = item && item[userRole] ? item[userRole].label : '';

        return label;
    };

    const getStatusLink = (data) => {
        const item = menuFolder[type][data.name];

        const link = item && item[userRole] ? item[userRole].url : '/all';
        const res = `${paths[type]}${link}`;

        return res;
    };

    const getColor = (data) => {
        const color =
            statusLookup.find((item) => {
                return data.name === item.key;
            })?.color || '#000';
        return color;
    };

    return (
        <SLayout>
            {data.map((item) => {
                return (
                    <OverviewCard
                        key={`${item.name}-${userRole}`}
                        name={getCardName(item)}
                        count={getDisplayCount2(item)}
                        link={`${getStatusLink(item)}`}
                        item={item}
                        color={getColor(item)}
                    />
                );
            })}
        </SLayout>
    );
};

export default CardLayout;
